import Vue from 'vue'
import confirm from './myToast.vue'

let confirmConstructor = Vue.extend(confirm)
const myToast = function (cont) {
  theConfirm(cont)
}
let theConfirm = function (cont, onClose) {
  // eslint-disable-next-line new-cap
  let confirmDom = new confirmConstructor({
    el: document.createElement('div')
  })
  confirmDom.cont = cont
  if (onclose) {
    confirmDom.onClose = function () {
      onClose()
    }
  }
  if (confirmDom.cont.duration == 0) {
  } else {
    setTimeout(function () {
      confirmDom.isShow = false
      confirmDom.onClose()
    }, confirmDom.cont.duration)
  }
  document.body.appendChild(confirmDom.$el)
}
// 全局注册
function registryToast () {
  Vue.prototype.$myToast = theConfirm
}
export default registryToast
export { myToast }



// WEBPACK FOOTER //
// ./src/components/myToast.js